const SET_DANH_SACH_LOAI_TRANG_THAI = (state, val) => {
  state.danhSachLoaiTrangThai = val
}

export default {
  SET_DANH_SACH_LOAI_TRANG_THAI,
}
